import { createSlice } from '@reduxjs/toolkit';

import { getSchoolCodes, generateCodes } from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  perPage: 10,
  totalPages: null as any,
};

const codesSlice = createSlice({
  name: 'schoolCodes',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getSchoolCodes.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(generateCodes.fulfilled, (state: any, action: any) => {
      return {
        ...state,
        data: [...state.data, ...action.payload],
      };
    });
  },
});

export default codesSlice.reducer;
